import MainTitle from '../../components/MainTitle'
import { NavLink, Navigate, useParams } from 'react-router-dom'
import CardButton from '../../components/CardButton'
import useAuth from '../../hooks/useAuth'

import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrashCan,
  faMagnifyingGlass,
  faEye,
  faPlus,
  faSort,
  faSortUp,
  faSortDown,
  faAngleDoubleLeft,
  faChevronLeft,
  faChevronRight,
  faAngleDoubleRight,
} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import moment from 'moment'
import SchoolNav from '../../components/SchoolNav'


function SchoolClients({type='cyp'}) {

  const { id } = useParams()
  const axios = useAxiosPrivate()
  const { setShowLoader, can, createInfo, auth } = useAuth()
  const [schoolFound, setSchoolFound] = useState(true)
  const [schoolData, setSchoolData] = useState({
    name: '',
    reference: 'WBA-1000',
  })
  const [unsavedChanges, setUnsavedChanges] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [cypClients, setCypClients] = useState([])
  const [ohClients, setOhClients] = useState([])

  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10)
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0)

  const [search, setSearch] = useState('')
  const [currentRecords, setCurrentRecords] = useState([])
  const [filteredRecords, setFilteredRecords] = useState([])
  const [nPages, setNumberOfPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage] = useState(10)
  const [modalTitle, setModalTitle] = useState('')
  const [deleteClient, setDeleteClient] = useState({})
  const [originalRecords, setOriginalRecords] = useState([])
  const [clientsLoaded, setClientsLoaded] = useState(false)

  const [debounceTimer, setDebounceTimer] = useState(null);
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc', 'desc', or null
  const [itemsPerPage, setItemsPerPage] = useState(0)
  const [totalItems, setTotalItems] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [fromItem, setFromItem] = useState(0)
  const [toItem, setToItem] = useState(0)
  const [totalClients, setTotalClients] = useState(0)

  const [dropdownValueRisk, setDropdownValueRisk] = useState('');
  const [risks, setRisks] = useState([]);
  const [riskFilter, setRiskFilter] = useState('');

  const [cypClientStatuses, setCypClientStatuses] = useState([]);
  const [ohClientStatuses, setOhClientStatuses] = useState([]);
  const [statusFilter, setStatusFilter] = useState('');
  const [dropdownValue, setDropdownValue] = useState('');

  const [isMissedReservationWindow, setIsMissedReservationWindow] = useState(false)
  const [columnClickCounts, setColumnClickCounts] = useState({})

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  });

  useEffect(() => {
    resetFilters();
  }, [type])

  useEffect(() => {
    if (debounceTimer) clearTimeout(debounceTimer);

    const timer = setTimeout(() => {
      getClients();
    }, 1500);

    setDebounceTimer(timer);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchClientStatuses();
    fetchRisks();
  }, [type]);

  useEffect(() => {
    getClients();
  }, [statusFilter, riskFilter, sortField, sortDirection, currentPage, type]);

  useEffect(() => {
    getSchoolById()
  }, [id])

  const isFilterApplied = () => {
    return statusFilter !== '' || search !== '' || riskFilter !== '';
  };

  const resetFilters = () => {
    setStatusFilter('');
    setRiskFilter('');
    setSearch('');
    setDropdownValue('');
    setDropdownValueRisk('');
    setIsMissedReservationWindow(false);
  };

  const fetchClientStatuses = async () => {
    try {
      let url = ''
      if (type === 'oh') {
        url = `/${type}-statuses/all`
      } else {
        url = `client-statuses/all`
      }

      const response = await axios.get(url);
      const statusTitles = response.data.result;
      const sortedStatuses = statusTitles.sort((a, b) => a.title.localeCompare(b.title));
      if (type === 'oh') {
        setOhClientStatuses(sortedStatuses);
      } else {
        setCypClientStatuses(sortedStatuses);
      }
    } catch (error) {
      createInfo('Error fetching client statuses')
    }
  };

  const fetchRisks = async () => {
    try {
      const response = await axios.get('/risk-options/all');
      const risks = response.data.result;
      setRisks(risks);
    } catch (error) {
      createInfo('Error fetching risks');
    }
  };

  const getClients = async () => {
    setShowLoader(true);
    setClientsLoaded(false)
    setTotalClients(0)
    try {
      const response = await axios.post(`/schools/${id}/${type}-clients`, {
        schoolId: id,
        searchTerm: search,
        sortField: sortField,
        riskFilter: riskFilter,
        statusFilter: statusFilter,
        sortDirection: sortDirection,
        perPage: recordsPerPage,
        page: currentPage,
        type: type,
      });

      let filteredClients = response.data.result.data;

      // if (riskFilter === "1") {
      //   filteredClients = filteredClients.filter((client) => client.risk[0].id === 1);
      // }
      
      if (response.data.result.pagination) {
        const pagination = response.data.result.pagination
        setTotalItems(pagination.total)
        setTotalPages(pagination.last_page)
        setItemsPerPage(pagination.per_page)
        setFromItem(pagination.from || 0)
        setToItem(pagination.to || 0)
      }
      setTotalClients(response.data.result.total);
      if (type === 'oh') {
        setCypClients(filteredClients);
      } else {
        setOhClients(filteredClients);
      }
      setOriginalRecords(filteredClients);
      setFilteredRecords(filteredClients);
      setCurrentRecords(filteredClients.slice(indexOfFirstRecord, indexOfLastRecord));
      setNumberOfPages(Math.ceil(filteredClients.length / recordsPerPage));
      setClientsLoaded(true)
    } catch (error) {
      console.error(error);
    }

    setShowLoader(false);
  };

  const handleStatusChange = (e) => {
    if (e.target.value === 'missed reservation window') {
      setIsMissedReservationWindow(true);
    } else {
      setIsMissedReservationWindow(false);
    }
    setStatusFilter(e.target.value);
    setDropdownValue(e.target.value);
  }

  const deleteClientClicked = (client) => {
    setDeleteClient(client)
    setModalTitle(`Delete client: ${client.name}`)
    setShowModal(true)
  }

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {

      if (key === 'risk') {
        const aRiskId = a.risk ? a.risk.id : Infinity;
        const bRiskId = b.risk ? b.risk.id : Infinity;

        if (aRiskId < bRiskId) return direction === 'ascending' ? -1 : 1
        if (aRiskId > bRiskId) return direction === 'ascending' ? 1 : -1
        return 0
      }

      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1
      return 0
    })
  }

  const renderSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === 'ascending') {
        return <FontAwesomeIcon icon={faSortUp} />;
      } else {
        return <FontAwesomeIcon icon={faSortDown} />;
      }
    }
    return <FontAwesomeIcon icon={faSort} />;
  };


  const getSchoolById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/schools/${id}`)

      if (!response.data.error) {
        await setSchoolData(response.data.result)

        // setEditContactMethod(contactMethodsArray)
        setSchoolFound(true)
      } else {
        setSchoolFound(false)
      }
      setShowLoader(false)
    } catch (error) {
      setSchoolFound(false)
    }
  }

  const handleSort = (key) => {
    let clicks = { ...columnClickCounts };

    if (!clicks[key]) clicks[key] = 1;
    else clicks[key]++;

    let nextDirection = 'asc'; // default = reset

    if (clicks[key] >= 3) {
      clicks[key] = 0; // reset cycle
      setSortField('name')   
    } else {
      if (clicks[key] === 2) {
        nextDirection = 'desc';
      }
      setSortField(key)
    }

    setColumnClickCounts(clicks);
    setSortDirection(nextDirection);
  };

  const handleRiskChange = (e) => {
    const value = e.target.value
    setRiskFilter(value);
    setDropdownValueRisk(value);
  }

  if (!schoolFound) {
    return <Navigate to="/404" replace />
  }

  if (!can('access school ' + type + ' clients')) {
    return <Navigate to="/permission-denied" replace />
  }

  return(
    <section>
      <MainTitle title={`School Client: ${schoolData?.name}`} backButton/>
      <SchoolNav active={`${type}-clients`} school={schoolData}/>


    <section>
        <ul className="flex just-between flex-wrap">
          {can('create clients') && type === 'cyp' && (
            <li className="w-1/4 mb-6 mr-3">
              <NavLink to="new">
                <CardButton icon={faPlus} title="Create New Client" />
              </NavLink>
            </li>
          )}
          <li className="rounded-md bg-white shadow h-20 w-1/4 px-4 mb-6 flex flex-col justify-center mr-3">
            <h2 className="font-bold">Total Clients</h2>
            <p className="text-3xl font-black">{totalClients}</p>
          </li>
        </ul>
      <section>
        <div className='flex flex-col md:flex-row justify-between '>
          <div className="py-4">
            <div className="relative mt-1">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </div>
              <input
                type="text"
                id="table-search"
                value={search}
                onChange={searchEvent => setSearch(searchEvent.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search Clients"
              />
            </div>
          </div>
          <div className="py-4">
            <select
              onChange={handleStatusChange}
              value={dropdownValue}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-md mr-2"
            >
              <option value="">Filter by Status</option>
              {type === 'oh' ? (
                <>
                  {ohClientStatuses.map((status, index) => (
                    <option key={index} value={status.id}>
                      {status.title}
                    </option>
                  ))}
                </>
              ) : (
                <>
                  {cypClientStatuses.map((status, index) => (
                    <option key={index} value={status.id}>
                      {status.title}
                    </option>
                  ))}
                </>
              )}

            </select>
            {type !== 'oh' && (
              <>
                <select
                  onChange={handleRiskChange}
                  value={dropdownValueRisk}
                  className='px-4 py-2 border border-gray-300 rounded-md shadow-md mr-2'
                >
                  
                  <option value="">Filter by Risk</option>
                  {risks.map((risk, index) => (
                    <option key={risk.id} value={risk.id}>
                      {risk.title}
                    </option>
                  ))}
                </select>
                {isFilterApplied() && (
                  <button
                    onClick={resetFilters}
                    className="bg-red-500 text-white rounded-lg px-4 py-2 ml-4"
                  >
                    Reset Filters
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="table-main">
            <thead>
              <tr>
                <th
                  className="cursor-pointer"
                  scope="col"
                  onClick={() => handleSort('id')}
                >
                  ID {renderSortArrow('id')}
                </th>
                <th
                  className="cursor-pointer"
                  scope="col"
                  onClick={() => handleSort('name')}
                >
                  Name {renderSortArrow('name')}
                </th>
                {type !== 'oh' && (
                  <th
                    className="cursor-pointer"
                    scope="col"
                    onClick={() => handleSort('reference')}
                  >
                    Reference {renderSortArrow('reference')}
                  </th>
                )}
                <th
                  className="cursor-pointer"
                  scope="col"
                  onClick={() => {type==='oh' ? handleSort('oh_status') : handleSort('status')}}
                >
                  Status {renderSortArrow('status')}
                </th>
                {type !== 'oh' && (
                  <th
                    className="cursor-pointer"
                    scope="col"
                    onClick={() => handleSort('risk')}
                  >
                    Risk {renderSortArrow('risk')}
                  </th>
                )}
                <th
                  className="cursor-pointer"
                  scope="col"
                  onClick={() => handleSort('created_at')}
                >
                  Created At {renderSortArrow('created_at')}
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="table-main">
              {currentRecords.length > 0 && clientsLoaded ? (
                currentRecords.map((client) => {
                  return (
                    <tr key={client.id}>
                      <td>{client.id}</td>
                      <td>{client.name}</td>
                      {type !== 'oh' && (
                        <td>{client.reference}</td>
                      )}
                      {type==='oh' ? (
                        <td>
                          <div className={`oh-status ${client.oh_status?.colour}`}>
                            {client.oh_status?.title}
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div
                            className={`status ${client.status
                              .replace(/\s+/g, '-')
                              .toLowerCase()}`}
                          >
                            {client.status}
                          </div>
                        </td>
                      )}

                      {type !== 'oh' && (
                        <td>{client.risk ? client.risk[0].title : 'N/A'}</td>
                      )}
                      <td>{moment(client.created_at).format('DD/MM/YYYY')}</td>
                      <td>
                        <div className="flex justify-center space-x-2">
                          <Link to={`/clients/${client.id}`}>
                            <span className="flex justify-center items-center bg-blue-400 rounded-md text-blue-800 h-9 w-12 hover:bg-blue-500 cursor-pointer">
                              <FontAwesomeIcon icon={faEye} />
                            </span>
                          </Link>
                          {isMissedReservationWindow && (
                            <span
                              onClick={() => deleteClientClicked(client)}
                              className="flex justify-center items-center bg-red-400 rounded-md text-red-800 h-9 w-12 hover:bg-red-500 cursor-pointer"
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={type==='oh' ? 6 : 8}>
                    <p className="no-records">No clients found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4">
          <p>
            {totalItems > 0 ? (
              `Showing ${fromItem} to ${toItem} of ${totalItems} results`
            ) : (
              'No results found'
            )}
          </p>
          <div className="flex">
            <button
              className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </button>
            <button
              className="relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
              Previous
            </button>
            <button
              className="relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
              <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
            </button>
            <button
              className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
            >
              <FontAwesomeIcon icon={faAngleDoubleRight} />
            </button>
          </div>
        </div>
      </section>

    </section>
        
      
    </section>
  )
}

export default SchoolClients